var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NotificationList',{attrs:{"title":'Senaste ansökningarna',"text-field":'notificationText',"icon":"notification_important","items":_vm.items},on:{"clicked":_vm.openCandidate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }